// extracted by mini-css-extract-plugin
module.exports = {"logoContainer":"style_logoContainer__NkIBU","logo":"style_logo__Ipf4q","logoText":"style_logoText__Zo5JY"};